import { VueRenderer } from "@tiptap/vue-3";
import { CommentMention } from "@/SharedComponents/CommentBox";

export default {
    render: () => {
        let component;
        const footer = document.getElementById("mention-container");

        return {
            onStart: (props) => {
                component = new VueRenderer(CommentMention, {
                    props,
                    editor: props.editor,
                });
                footer.append(component.element);
            },
            onUpdate(props) {
                component.updateProps(props);
            },
            onKeyDown(props) {
                if (props.event.key === "Escape") {
                    component.destroy();
                    return true;
                }
                return component.ref?.onKeyDown(props);
            },
            onExit() {
                component.destroy();
            },
        };
    },
};
